import { render, staticRenderFns } from "./WebsiteLogo.vue?vue&type=template&id=785b4329&scoped=true"
import script from "./WebsiteLogo.vue?vue&type=script&lang=js"
export * from "./WebsiteLogo.vue?vue&type=script&lang=js"
import style0 from "./WebsiteLogo.vue?vue&type=style&index=0&id=785b4329&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785b4329",
  null
  
)

export default component.exports